var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkOff = function SvgLinkOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m19.261 15.577-1.134-1.165a3 3 0 0 0 1.63-1.082q.62-.807.62-1.857 0-1.26-.885-2.149a2.9 2.9 0 0 0-2.134-.89H13.55v-1.5h3.808q1.873 0 3.196 1.329 1.323 1.327 1.323 3.21 0 1.329-.714 2.428a4.64 4.64 0 0 1-1.902 1.676m-3.303-3.354-1.5-1.5h1.65v1.5zm4.565 9.504-18.4-18.4 1.054-1.054 18.4 18.4zm-9.32-5.715H7.416q-1.883 0-3.21-1.328-1.328-1.329-1.328-3.21 0-1.668 1.074-2.927a4.35 4.35 0 0 1 2.695-1.52h.23l1.409 1.408h-.87q-1.26 0-2.149.89a2.93 2.93 0 0 0-.89 2.148q0 1.26.89 2.15t2.15.889h3.788zm-2.557-3.789v-1.5h1.942l1.475 1.5z"
  })));
};
export default SvgLinkOff;